<template>
    <div class="main-center" style="margin-top: 80px;height: 100%">
        <div class="bkElement">
            <p class="bkTitle">FreeTime查询</p>
        </div>
        <div>
            <div>
              <el-button class="queryType" style="color: white;background-color: #EC252DFF">
                提单号：
              </el-button>
                <el-input v-model="search.ydhTxt" class="ydhTxt"
                          :placeholder="请输入提单号进行查询"
                          clearable
                @input="formatUpper('search','ydhTxt',search.ydhTxt)"/>
                <el-button class="searchButton" @click="selectAllYDH"
                           icon="el-icon-search">查询
                </el-button>
            </div>
        </div>
        <div v-if="showNoDataView" class="noData">
            <no-data-view/>
        </div>

        <!--查询结果-->
        <div v-if="!showNoDataView" class="searchList">
            <div class="cardBody" v-for="(i,j) in cargoTrackInfos" :key="j">
                <!--<el-collapse v-model="activeNames" @change="handleChange">
                    <el-collapse-item>
                        <template slot="title">-->
                <div>
                    <img src="../../assets/image/icon/order2.svg" alt="">
                    <span class="bkTitle2">FreeTime信息</span>
                </div>
                <!--                        </template>-->
                <!--提单信息-->
                <div style="font-weight:bold;background: white">
                    <el-row>
                      <p/>&nbsp;
                      <el-col style="width: 24%">
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <span class="span-left">船名</span>
                        <span>：{{i.VESSEL_CODE}}</span>
                      </el-col>
                      <el-col style="width: 24%">
                        <span class="span-left">航次</span>
                        <span>：{{i.VOYAGE_NO}}</span>
                      </el-col>
                      <el-col style="width: 24%">
                        <span class="span-left">提单号</span>
                        <span>：{{i.BL_NO}}</span>
                      </el-col>
                      <el-col style="width: 24%">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <span class="span-left">箱型箱量</span>
                        <span>：{{i.CONTAINER_TYPE}}</span>
                      </el-col>
                    </el-row>
                  <el-row>
                    <p/>&nbsp;
                    <el-col style="width: 24%">
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      <span class="span-left">DEM购买天数</span>
                      <span>：{{i.FREE_TIME_DEM_DAYS}}</span>
                    </el-col>
                    <el-col style="width: 24%">
                      <span class="span-left">DEM免费规则</span>
                      <span>：{{i.DEMURRAGE_TYPE}}</span>
                    </el-col>
                    <el-col style="width: 24%">
                      <span class="span-left">DET购买天数</span>
                      <span>：{{i.FREE_TIME_DET_DAYS}}</span>
                    </el-col>
                    <el-col style="width: 24%">
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      <span class="span-left">DET免费规则</span>
                      <span>：{{i.DETENTION_TYPE}}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <p/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <el-col style="width: 24%">
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      <span class="span-left">装港</span>
                      <span>：{{i.POL}}</span>
                    </el-col>
                    <el-col style="width: 24%">
                      <span class="span-left">卸港</span>
                      <span>：{{i.POD}}</span>
                    </el-col>
                    <el-col style="width: 24%">
                      <span class="span-left">接货地</span>
                      <span>：{{i.RECEIPT}}</span>
                    </el-col>
                    <el-col style="width: 24%">
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      <span class="span-left">目的地</span>
                      <span>：{{i.DESTINATION}}<p/></span>
                    </el-col>
                  </el-row>
                </div>

                <!--</el-collapse-item>
            </el-collapse>-->
            </div>

        </div>
        <div style="font-weight:bold;">
        </div>
        <div class="footerSpan" style="margin-top: 200px">
            <span></span>
        </div>
    </div>
</template>

<script>
    import noDataView from "@/components/noDataView";

    export default {
        name: "cargoTrack",
        computed: {
            trackSearchButton() {
                return this.$t("common.trackSearchButton");
            },
        },
        components: {
            noDataView
        },
        data() {
            return {
                activeNames: ['1'],
                //控制按钮重复点击
                isSelectClick: false,
                showNoDataView: true,
                search: {
                    ydhTxt: "",
                    queryType: "1",
                },
                cargoTrackInfos: [],
            }
        },
        mounted() {

        },
        methods: {
            selectAllYDH() {
                //校验单号是否为空
                if (this.search.ydhTxt == "") {
                    this.showMessage(false, this.$t("message.enterNo"), "warning");
                    return
                }

                //获取查询类型 1:提单号 2:箱号
                if (!this.isSelectClick && this.search.queryType) {

                    var valIn = this.search.ydhTxt.replace(/\s/g, "");
                    var arrYdh = valIn ? this.unique(valIn.split(",")) : [];
                    if (arrYdh.length > 0 && arrYdh.length <= 1) {
                        //显示进度条
                        // 声明一个loading对象
                        this.loadingtuo = this.$loading({
                            lock: true, // 设置加载时是否锁屏,锁屏状态加载区域无法操作
                            text: this.$t('message.searching'),    //加载动画的文字
                            spinner: 'el-icon-loading',             // 引入的loading图标
                            background: "rgb(0,0,0,0.1)",
                            target: document.querySelector(".searchList") // 设置加载动画区域
                        });
                        let that = this;
                        this.isSelectClick = true;
                        //查运单号 信息(运单号，箱型，暂扣信息，提箱信息)
                        this.axios({
                            method: "post",
                            url: "/api/freeTime/findFreeTimeByBlNo?blNo=" + valIn,
                            data: {
                            },
                            headers: {
                                'Accept-language': localStorage.getItem("locale"),
                                'Content-type': 'application/json;charset=utf-8'
                            }
                        }).then(response => {
                            if (response.data.backCode === "200") {
                              console.log(response.data.object)
                                if(response.data.object.list.length && response.data.object.list.length > 0){

                                    this.showNoDataView = false;
                                    this.cargoTrackInfos = response.data.object.list;

                                }else{
                                    this.showNoDataView = true;
                                }
                            } else {
                                this.showNoDataView = true;
                                this.showMessage(false, this.responseCode, "error");
                            }
                        }).catch(error => {
                            if (error.data) {
                                this.responseCode = error.data.backMessage;
                                this.showMessage(false, this.responseCode, "error");
                            } else {
                                this.showMessage(false, error, "error");
                            }
                        });
                        that.loadingtuo.close();
                    } else if (arrYdh.length > 1) {
                        this.showMessage(false, this.$t("message.notSupportMulti"), "error");
                        this.showNoDataView = true;
                    }
                    this.isSelectClick = false;
                }
            },
            getDisplayValue(item) {
                return localStorage.getItem('locale') == 'en' ? item.displayValue : item.displayValueCn;
            },
            unique(arr) {//数组去重
                //Set数据结构，它类似于数组，其成员的值都是唯一的
                return Array.from(new Set(arr)); // 利用Array.from将Set结构转换成数组
            },
            handleChange(val) {
                console.log(val);
            }
        }
    }
</script>

<style lang="scss">

    .bkTitle {
        font-size: 25px;
        margin: 20px auto;
        font-weight: bold;
    }

    .bkTitle2 {
        width: 80%;
        font-size: 19px;
    }

    .queryType {
        border: 0;
        width: 150px;

        .el-input {
            input {
                color: #fff;
                background-color: #EE2C2C;
                font-size: 15px;
            }
        }
    }

    .input-group {
        position: relative;
        display: table;
        border-collapse: separate;
    }

    .ydhTxt {
        font-size: 15px;
        width: 400px;
    }

    .searchButton {
        font-size: 15px;
        background-color: #EE2C2C;
        color: #fff;
        border-color: transparent;
    }

    .noData {
        height: 100%;
        margin: 15px 0;
        background-color: #ffffff;
    }

    .noData2 {
        margin-left: 50px;
        height: 100%;
        background-color: #ffffff;
    }

    .searchList {
        margin: 15px 0;
    }

    .span-group {
        flex: 1;
        width: 650px;
        border: 0;
        line-height: 44px;
        height: 40px;
        margin-left: 50px;
    }

    .span-left {
        width: 150px;
    }

    .span-right {
        width: 500px;
    }

</style>